import { useQuery } from "@tanstack/react-query";
import { adminService } from "../services/admin.service";

export function useOrganisations(page: number, size: number, search: string) {
  return useQuery({
    queryKey: ["admin-orgs", page, size, search],
    queryFn: () => adminService.listOrganisations(page, size, search || undefined),
  });
}

export function useOrganisationDetail(id: string) {
  return useQuery({
    queryKey: ["admin-org", id],
    queryFn: () => adminService.getOrganisationDetail(id),
    enabled: !!id,
  });
}
